import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { Link } from 'react-router-dom';
import { useModal } from '../context/ModalContext';

export const Hero: React.FC = () => {
  const { openAuditModal, openRequestCallModal } = useModal();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-blue-600/20 rounded-full blur-[120px] pointer-events-none opacity-60" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <FadeIn>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm mb-8">
            <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" />
            <span className="text-xs font-medium text-blue-200 uppercase tracking-wider">Accepting New Clients</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1}>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter mb-6 bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-neutral-500 pb-2">
            Transform Your Business with Powerful Web Solutions
          </h1>
        </FadeIn>

        <FadeIn delay={0.2}>
          <p className="text-lg md:text-xl text-neutral-400 mb-10 max-w-2xl mx-auto leading-relaxed">
            From website redesigns to brand new creations, professional catalogues to digital banners—we build everything you need to scale globally.
          </p>
        </FadeIn>

        <FadeIn delay={0.3}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <motion.button
              onClick={openAuditModal}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-white text-neutral-950 font-semibold rounded-full flex items-center gap-2 hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-shadow cursor-pointer"
            >
              Get Free Audit
              <ArrowRight size={18} />
            </motion.button>
            <motion.button
              onClick={openRequestCallModal}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-500 text-white font-semibold rounded-full flex items-center gap-2 hover:shadow-[0_0_20px_rgba(168,85,247,0.4)] transition-shadow cursor-pointer"
            >
              Request Zoom Call
              <Phone size={18} />
            </motion.button>
            <Link
              to="/services"
              className="px-8 py-4 text-white font-medium hover:text-neutral-300 transition-colors"
            >
              View Services
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
